/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the ExternalAdUnit HTTP resource (factory product). */
export class ExternalAdUnitResource {
}

export function createExternalAdUnitResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const ExternalAdUnit = createAdnHttpResource(send, 'externaladunits', () => localUserProfile, 'externalAdUnit');

  ExternalAdUnit.create = function(defaults: any): any {
    return new ExternalAdUnit(_.merge({}, defaults));
  };

  return ExternalAdUnit;
}

export const externalAdUnitResourceProvider = {
  provide: ExternalAdUnitResource,
  useFactory: createExternalAdUnitResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

